module.exports = __webpack_public_path__ + "static/img/3-1.d6fafdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3-1.jpg
// module id = +DRt
// module chunks = 0